import gql from 'graphql-tag';
import React from 'react';
import { useState } from 'react';
import { Mutation } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import SpinLoader from '../../components/SpinLoader';
import { Input } from '../../components/TextInput';
import withSession from '../../lib/withSession';
import { useEffect } from 'react';
import { ADVERTISE_SMS_LOGIN } from '../../graphql';

const GENERATE_CODE = gql`
  mutation getSmsLoginActivationOtp {
    getSmsLoginActivationOtp {
      ok
      reason
    }
  }
`;
const ACTIVATE_FEATURE = gql`
  mutation verifySmsLoginActivationOtp($otp: String!) {
    verifySmsLoginActivationOtp(otp: $otp) {
      ok
      reason
    }
  }
`;
const convertErrorCodeToString = (errorCode) => {
  if (!errorCode) return 'An error occured';

  switch (errorCode) {
    case 'ALREADY_ACTIVE':
      return 'The feature is already active on your account';
    case 'ALREADY_SENT':
      return 'A code has already been sent to you recently';
    case 'ATTEMPTS_BLOCKED':
      return 'Attempts blocked for 24 hours';
    case 'INVALID':
      return 'Incorrect code';
    case 'CODE_TOO_OLD':
      return 'Code expired';
    default:
      return 'An error occured';
  }
};

export const LoginSmsFeatureActivated = withRouter(({ history, onClose }) => {
  return (
    <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
      <Heading mb={4}>One-time code Enabled!</Heading>

      <Text mb={3} textAlign={'center'}>
        Next time you log in, you can use a one-time code sent to your phone to authenticate.
      </Text>

      <Button
        onClick={() => {
          if (!!onClose) {
            onClose();
          } else {
            history.push('/');
          }
        }}
        variant={'primary'}
        style={{ alignSelf: 'center', width: 'fit-content' }}
      >
        Close
      </Button>
    </Flex>
  );
});

const InitialStep = ({ onSent, onDismiss }) => {
  const [errors, setErrors] = useState(null);
  return (
    <Flex flexDirection={'column'} alignItems={'center'}>
      <Heading mb={4}>Activate Login with SMS</Heading>

      <Text textAlign={'center'} mb={3}>
        When activated, after entering your email on the login page, you'll see a button to continue signing in with a code you'll receive by SMS
      </Text>
      <Text textAlign={'center'}>To activate the feature, click the button below. We'll send you a code by SMS in order to verify it's your phone number.</Text>

      <Mutation
        mutation={GENERATE_CODE}
        onCompleted={(data) => {
          if (data.getSmsLoginActivationOtp) {
            if (data.getSmsLoginActivationOtp.reason === 'ALREADY_SENT') {
              onSent();
              return;
            }
            if (!data.getSmsLoginActivationOtp.ok || data.getSmsLoginActivationOtp.reason) {
              setErrors(convertErrorCodeToString(data.getSmsLoginActivationOtp.reason));
              return;
            }
            onSent();
          }
        }}
      >
        {(mutate, { loading, error }) => (
          <Button mt={4} onClick={mutate} disabled={loading || !!errors} variant={'primary'} style={{ alignSelf: 'center', width: 'fit-content' }}>
            Activate Feature
          </Button>
        )}
      </Mutation>

      <Text style={{ color: '#0468ffff', cursor: 'pointer', textDecoration: 'underline' }} textAlign={'center'} mt={4} onClick={onDismiss}>
        {`Close >`}
      </Text>
    </Flex>
  );
};

const OtpInner = withSession(({ onActivated, goBack, session, dontReceive, reject }) => {
  const [value, setValue] = useState();
  const [errors, setErrors] = useState(null);

  if (errors) {
    if (errors.value !== 'INVALID' && errors.value !== 'ALREADY_ACTIVE') {
      return (
        <Flex alignItems={'center'}>
          <Heading textAlign="center" mb={4}>
            Unable to activate feature
          </Heading>

          <Text mb={3}>{errors.label}</Text>

          <Button onClick={reject} variant={'primary'} style={{ alignSelf: 'center', width: 'fit-content' }}>
            Go Back
          </Button>
        </Flex>
      );
    }
  }

  return (
    <Mutation
      mutation={ACTIVATE_FEATURE}
      refetchQueries={[{ query: ADVERTISE_SMS_LOGIN }]}
      awaitRefetchQueries={true}
      onCompleted={(data) => {
        setValue(null);
        if (data.verifySmsLoginActivationOtp) {
          if (!data.verifySmsLoginActivationOtp.ok || data.verifySmsLoginActivationOtp.reason) {
            if (data.verifySmsLoginActivationOtp.reason === 'ALREADY_ACTIVE') {
              onActivated();
              return;
            }
            setErrors({
              value: data.verifySmsLoginActivationOtp.reason,
              label: convertErrorCodeToString(data.verifySmsLoginActivationOtp.reason),
            });
            return;
          }
          onActivated();
        }
      }}
    >
      {(mutate, { loading }) => (
        <Flex mb={4} flexDirection="column" alignItems={'center'}>
          <Box
            px={2}
            style={{
              width: '100%',
            }}
          >
            {!loading ? (
              <>
                <Heading textAlign="center" mb={3}>
                  We sent you an SMS code
                </Heading>

                <Text textAlign={'center'}>
                  Enter the code sent to your phone number {session.phone}.<br />
                  <br />
                  The code expires in 3 minutes.
                </Text>
              </>
            ) : (
              <Text>Verifying...</Text>
            )}
          </Box>
          {loading ? (
            <Flex
              px={2}
              flexDirection="column"
              style={{
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '40px',
              }}
            >
              <SpinLoader />
            </Flex>
          ) : (
            <Flex px={2} flexDirection="column">
              <Text mb={2} textAlign="center" mt={3} style={{ fontWeight: 600 }}>
                Enter your code here
              </Text>
              <Flex justifyContent="center" alignItems="center" flexDirection="column">
                <Input
                  style={{
                    maxWidth: '250px',
                    fontSize: '28px',
                    letterSpacing: '16px',
                    textAlign: 'center',
                  }}
                  placeholder="••••••"
                  autoComplete="one-time-code"
                  onChange={(r) => {
                    setValue(r.target.value);
                    if (r.target.value.length === 6) {
                      setErrors(null);
                      mutate({
                        variables: {
                          otp: r.target.value,
                        },
                      });
                    }
                  }}
                  autoFocus
                  value={value}
                />
              </Flex>
              {errors && errors.label&&(
              <Text style={{ color: '#cf3a0cff', cursor: 'pointer' }} textAlign={'center'} mt={3} mb={2}>
                {errors.label}
              </Text>
              )}
              <Text style={{ color: '#ff6804ff', cursor: 'pointer' }} textAlign={'center'} mt={3} onClick={dontReceive}>
                { `I'm not receiving any codes >`}
              </Text>
            </Flex>
          )}
        </Flex>
      )}
    </Mutation>
  );
});

export const ActivateSmsLoginFeature = withRouter(({ reject, initialStepId = 0, history, onStepChanged, onClose, onActivated }) => {
  const [step, setStep] = useState(initialStepId);

  useEffect(
    () => {
      if (onStepChanged) {
        onStepChanged(step);
      }
    },
    [step]
  );

  if (step === 0) {
    return (
      <Flex flexDirection={'column'} mt={4}>
        <InitialStep onSent={() => setStep(1)} onDismiss={onClose} />
      </Flex>
    );
  }

  if (step === 1) {
    return (
      <Flex flexDirection={'column'} mt={4}>
        <OtpInner
          onActivated={() => {
            if (onActivated) {
              onActivated();
            } else {
              setStep(2);
            }
          }}
          goBack={() => setStep(1)}
          dontReceive={() => setStep(3)}
          reject={() => {
            if (!!reject) {
              reject();
            } else {
              if (history) {
                history.goBack();
              }
            }
          }}
        />
      </Flex>
    );
  }

  if (step === 2) {
    return (
      <Flex flexDirection={'column'} mt={4}>
        <LoginSmsFeatureActivated onClose={onClose} />
      </Flex>
    );
  }

  if (step === 3) {
    return (
      <Flex alignItems={'center'} justifyContent={'center'}>
        <Heading textAlign="center" mb={4}>
          Do you need to update your phone number?
        </Heading>

        <Text mb={3}>Please reach out to care@palomahealth.com so that we can help you and make sure we have the correct phone number on file</Text>

        <Button onClick={reject} variant={'primary'} style={{ alignSelf: 'center', width: 'fit-content' }}>
          Close
        </Button>
      </Flex>
    );
  }

  return null;
});
